export default __webpack_public_path__ + "static/media/movie-info-min.cf7d6b6e.png";